export interface VehicleProfile {
  id: string;
  userId: string;
  nickname?: string;
  year?: string;
  make?: string;
  model?: string;
  trim?: string;
  vin?: string;
  plate?: string;
  notes?: string;
  isDefault?: boolean;
  createdAt: string;
  updatedAt: string;
}

export function formatVehicleLabel(v: Partial<VehicleProfile>): string {
  const parts: string[] = [];
  const y = (v.year || '').trim();
  const make = (v.make || '').trim();
  const model = (v.model || '').trim();
  const trim = (v.trim || '').trim();

  if (y) parts.push(y);
  if (make) parts.push(make);
  if (model) parts.push(model);
  if (trim) parts.push(trim);

  const base = parts.join(' ');
  const nickname = (v.nickname || '').trim();

  if (nickname && base) return `${nickname} • ${base}`;
  if (nickname) return nickname;
  if (base) return base;
  return 'Vehicle';
}

export function formatVehicleDetailsForNotes(v: Partial<VehicleProfile>): string {
  const label = formatVehicleLabel(v);
  const plate = (v.plate || '').trim();
  const vin = (v.vin || '').trim();

  const extras: string[] = [];
  if (plate) extras.push(`Plate ${plate}`);
  if (vin) extras.push(`VIN ${vin}`);

  return extras.length ? `${label} (${extras.join(', ')})` : label;
}

